<template>

  <v-container fluid>
    <p class="font-weight-bold title">Список новых заявлений абитуриентов</p>
    <v-sheet>
      <v-simple-table
      :fixed-header="fixedHeader"
      :height="height"
      >
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-center">№ заявления</th>
            <th class="text-center">Тип заявления</th>
            <th class="text-center">ФИО</th>
            <th class="text-center">Время подачи заявления</th>
            <th class="text-center">Действия</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in applications" :key="item.id">
            <td class="text-center">{{ item.id }}</td>
            <td class="text-center">{{ item.application_type.education_level_name }}</td>
            <td class="text-center">{{ item.abiturient.last_name +' '+ item.abiturient.first_name }}</td>
            <td class="text-center">{{ item.datetime }}</td>
            <td class="text-center"><v-btn color="success" v-on:click="getWork(item.id,user.id)">Принять в работу</v-btn></td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-sheet>
  </v-container>
</template>

<script>
  import {mapGetters} from 'vuex';
  import Vue from 'vue';

  export default {
    name: "list",
    data: () => ({
      fixedHeader: true,
      height: 600,
    }),
      created () {
        this.beforeCreate();
        this.timer = setInterval(this.beforeCreate, 1000)
    },
    methods: {
      getWork: function (application, user) {
        Vue.axios.post('operator/is_work/', {application, user})
          .then(function () {
            console.log('SUCCESS!!');
          })
          .catch(function () {
            console.log('FAILURE!!');
          });
        this.$store.dispatch('operator/loadApplications');
      },
      beforeCreate() {
            this.$store.dispatch('operator/loadApplications');
      },
    },
    beforeDestroy () {
      clearInterval(this.timer)
    },
    computed: {
      ...mapGetters("operator", ["applications"]),
      ...mapGetters("auth", ["user"])
    },
  };
</script>
